export type CookiePreferencesCopy = {
    summaryEyebrow: string;
    summaryTitle: string;
    summaryBody: string;
    privacyPolicyPrefix: string;
    privacyPolicyLabel: string;
    declineLabel: string;
    manageLabel: string;
    acceptLabel: string;
    manageEyebrow: string;
    manageTitle: string;
    backLabel: string;
    essentialTitle: string;
    essentialDescription: string;
    essentialStatusLabel: string;
    analyticsTitle: string;
    analyticsDescription: string;
    offLabel: string;
    onLabel: string;
    saveLabel: string;
    triggerLabel: string;
};

export const DEFAULT_COOKIE_PREFERENCES_COPY: CookiePreferencesCopy = {
    summaryEyebrow: 'EnterpriseKC privacy',
    summaryTitle: 'Your privacy, your choice',
    summaryBody: 'We use optional analytics to understand how the site is used. You can accept, decline, or choose what works for you.',
    privacyPolicyPrefix: 'Read our',
    privacyPolicyLabel: 'privacy policy',
    declineLabel: 'Decline analytics',
    manageLabel: 'Manage preferences',
    acceptLabel: 'Accept analytics',
    manageEyebrow: 'Privacy controls',
    manageTitle: 'Manage cookie preferences',
    backLabel: 'Back',
    essentialTitle: 'Essential cookies',
    essentialDescription: 'Required for security, saved privacy choices, and core site features.',
    essentialStatusLabel: 'Always on',
    analyticsTitle: 'Analytics cookies',
    analyticsDescription: 'Help us understand site usage through Google Analytics and Lucky Orange.',
    offLabel: 'Off',
    onLabel: 'On',
    saveLabel: 'Save preferences',
    triggerLabel: 'Cookie preferences',
};

export const withCookiePreferencesCopyDefaults = (
    value?: Partial<CookiePreferencesCopy> | null,
): CookiePreferencesCopy => Object.entries(DEFAULT_COOKIE_PREFERENCES_COPY).reduce(
    (copy, [key, fallback]) => {
        const candidate = value?.[key as keyof CookiePreferencesCopy];
        copy[key as keyof CookiePreferencesCopy] = typeof candidate === 'string' ? candidate : fallback;
        return copy;
    },
    { ...DEFAULT_COOKIE_PREFERENCES_COPY },
);

export const normalizeCookiePreferencesCopy = (
    value?: Partial<CookiePreferencesCopy> | null,
): CookiePreferencesCopy => Object.entries(withCookiePreferencesCopyDefaults(value)).reduce(
    (copy, [key, candidate]) => {
        const fallback = DEFAULT_COOKIE_PREFERENCES_COPY[key as keyof CookiePreferencesCopy];
        copy[key as keyof CookiePreferencesCopy] = candidate.trim() || fallback;
        return copy;
    },
    { ...DEFAULT_COOKIE_PREFERENCES_COPY },
);
